import React from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import s from "./WhyWeExist.css";
import cx from "classnames";

import messages from "../../locale/messages";
import { imageCdnUrl } from "../../config";
import { Col, Row } from "react-bootstrap";
class WhyWeExist extends React.Component {
  render() {
    const { intl } = this.props;

    const htmlContent = intl.formatMessage(messages.WhyWeExistContent);

    return (
      <div className={cx(s.container, s.whyWeExist, "whyWeExistBg")}>
        <div className={cx(s.container)}>
          <Row>
            <Col xs={12} sm={7} md={8} lg={8}>
              <h2 className={cx(s.sectionTitle, "textWhite")}>
                <FormattedMessage {...messages.WhyWeExist} />
              </h2>
              <div
                className={s.sectionContent}
                dangerouslySetInnerHTML={{
                  __html: htmlContent,
                }}
              />
            </Col>
            <Col xs={12} sm={5} md={4} lg={4} className={s.textEnd}>
              <img
                src={`${imageCdnUrl}staticImages/whyWeExistImage.png`}
                className={cx(s.footerVector, "weExistRtl")}
              />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default injectIntl(withStyles(s)(WhyWeExist));
